
export default {
  mounted(el, binding) {
    el.__handler__ = (event) => {
      if (!el.contains(event.target)) {
        binding.value(event);
      }
    };

    // 🔥 delay to prevent immediate close
    setTimeout(() => {
      document.addEventListener("click", el.__handler__);
    }, 0);
  },

  unmounted(el) {
    document.removeEventListener("click", el.__handler__);
  },
};